var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lang === 'he')?_c('CdnLogoHe'):_c('CdnLogo')
}
var staticRenderFns = []

export { render, staticRenderFns }